<template>
    <div class="af">
        <el-form class="form"  :model="formData" :rules="formRules" ref="formRef" label-width="80px" size="mini" :inline="true">
<!--                <div >-->
                    <el-form-item class="form-title num" prop="num" label="No:" >
                        <span  v-model="formData.num" style="color:#b3d268;font-size: 16px;font-style: italic;width: 150px;">{{formData.num}}</span>
                    </el-form-item>
                    <el-form-item class="form-title" prop="gsname" :label="$t('form_company')" >
                        <el-select v-model="formData.gsname" :placeholder="$t('form_please_select_a_company')" filterable required clearable disabled>
                            <el-option
                                    v-for="item in companyName"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
<!--                                <span  style="display: inline-block;width: 100%">{{item.vc_name}}</span>-->
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="bmname" :label="$t('form_receiving_department')" >
                        <el-select v-model="formData.bmname" :placeholder="$t('form_please_select_department')"  filterable required clearable disabled>
                            <el-option
                                    v-for="itembm in groupName"
                                    :key="itembm.i_id"
                                    :label="itembm.vc_name"
                                    :value="itembm.i_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="ckname" :label="$t('form_warehouse')" >
                        <el-select v-model="formData.ckname" :placeholder="$t('form_please_select_warehouse')" filterable required clearable disabled>
                            <el-option
                                    v-for="one in warehouseName"
                                    :key="one.i_id"
                                    :label="one.vc_name"
                                    :value="one.i_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="sqName" :label="$t('form_applicant')" >
                        <el-select v-model="formData.sqName" :placeholder="$t('form_please_select_the_applicant')"  filterable required clearable disabled>
                            <el-option
                                    v-for="itemsq in personName"
                                    :key="itemsq.i_id"
                                    :label="itemsq.vc_name"
                                    :value="itemsq.i_id">
                            </el-option>

                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="gsname" label="货权公司" >
                        <el-select v-model="formData.i_hqgsid"  :disabled="i_pid==0?false:true" :placeholder="$t('form_please_select_a_company')" filterable required clearable >
                            <el-option
                                    v-for="item in companyName_hq"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                                <!--                                <span  style="display: inline-block;width: 100%">{{item.vc_name}}</span>-->
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="formData.i_hqgsid!==gsid" class="form-title" prop="gsname" label="直销部门" >
                        <span  style="display: inline-block;width: 195px">{{formData.vc_directsell_deptname}}</span>
                    </el-form-item>
                    <el-form-item v-if="formData.i_hqgsid!==gsid" class="form-title" prop="gsname" label="直销业务" >
                        <el-input style="width: 195px"  :disabled="i_pid==0?false:true" @change="searchdata" v-model="formData.vc_directsell_uname" placeholder="请输入业务员"  size="mini"></el-input>
                    </el-form-item>

<!--                </div>-->
            <div style="margin-bottom: 20px">
                <el-table class="table"
                        border
                        ref="multipleTable"
                        :data="tableData"
                        height="255"
                        size="mini"
                        :row-class-name="tableRowClassName"
                        tooltip-effect="dark"
                        >
                    <el-table-column
                            :label="$t('form_serial_number')"
                            align="left"
                            type="index"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_gsname"
                            :label="$t('form_company')"
                            width="150"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_pzname"
                            :label="$t('form_product_name')"
                            show-overflow-tooltip
                            width="120">
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_no"
                            :label="$t('form_batch_number')"
                            show-overflow-tooltip
                            width="120">
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_no_hs"
                            label="成本核算批次"
                            show-overflow-tooltip
                            width="120">
                    </el-table-column>
                    <el-table-column
                            v-if="i_pid==0"
                            align="left"
                            prop="kysl"
                            :label="$t('form_available_stock')"
                            width="80"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            v-if="i_pid==0"
                            align="left"
                            prop="f_num"
                            :label="$t('promanagement_apply_for_outbound_quantity')"
                            width="110">
                        <template slot-scope="scope">
                            <el-form-item class="tableForm-item" :prop="'tableData.'+scope.$index+'.f_num'" :rules="formRules.f_num">
                                <el-input-number :controls="false" :min="0" :precision="$setPrecision.quantityPrecision" class="changeinput" size="mini" v-model="scope.row.f_num" @change="numinput(scope.row)"></el-input-number>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                            v-if="i_pid!=0"
                            align="left"
                            prop="f_num"
                            :label="$t('form_quantity')"
                            width="80"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            v-if="i_pid!=0"
                            align="left"
                            prop="f_outnum"
                            :label="$t('promanagement_outbound_quantity')"
                            width="80"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_unit"
                            :label="$t('form_metering')"
                            width="80"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            v-if="i_pid==0"
                            align="left"
                            prop="vc_note"
                            :label="$t('form_describe')"
                            width="90">
                        <template  slot-scope="scope" >
                            <el-form-item  class="tableForm-item" :prop="scope.row.vc_note" style="width: 100%;padding: 0">
                                <el-input class="changeinput" size="mini" v-model="scope.row.vc_note" style="width: 100%;padding: 0"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                            v-if="i_pid!=0"
                            align="left"
                            prop="vc_note"
                            :label="$t('form_describe')"
                            width="90">
                    </el-table-column>
                    <el-table-column align="center"  width="50"  v-if="i_pid==0">
                        <template slot="header" slot-scope="scope">
                            <el-popover
                                    class="pop"
                                    placement="bottom-end"
                                    width="1000"
                                    trigger="manual"
                                    v-model="visible">
                                <template>
                                    <product-details v-if="visible==true" :productDetails="productDetails" @closePop="closePop" @transValue="transValue"></product-details>
                                </template>
                                <el-button class="addbtn" @click="popShow" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>
                            </el-popover>
                        </template>
                        <template  slot-scope="scope">
                            <div class="iconminus">
                                <span class="minus" @click="deleteRow(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-form-item class="form-title" prop="vc_note" :label="$t('form_notes')" >
                <el-input  v-model="formData.vc_note" >
                </el-input>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_lruname" :label="$t('form_creator')" >
                <el-input  v-model="formData.vc_lruname" disabled>
                </el-input>
            </el-form-item>
            <el-form-item class="form-title" prop="date" :label="$t('form_date')" >
                <el-input  v-model="formData.date" disabled>
                </el-input>
            </el-form-item>
            <el-form-item class="form-title" prop="dt_accounttime" :label="$t('promanagement_accountingTime')" >
                <el-input  v-model="formData.dt_accounttime" disabled>
                </el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">

            <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="small">{{$t('button_save')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
<!--            <el-button type="primary" @click="toApprove" v-if="state==0" :disabled="disabled" :class="baseerp+'btn'">提交审批</el-button>-->
        </div>

            <el-dialog :class="baseerp+'div'" title="人员信息" width="60%"  :visible.sync="dialogVisible" top="15vh"
                       :close-on-click-modal="false" append-to-body  @close="closPer">
                <el-table class="mrt10" ref="table" size="mini" height="400px" border @row-click="rowClick" :data="personData" :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
                    <el-table-column type="index" width="60" :label="$t('form_serial_number')"></el-table-column>
                    <el-table-column prop="vc_directsell_uname" label="姓名"  show-overflow-tooltip></el-table-column>
                    <el-table-column prop="vc_directsell_deptname" label="部门"  show-overflow-tooltip></el-table-column>
                </el-table>
                <div slot="footer" class="dialog-footer" style="text-align: center;margin-top: 20px">
                    <el-button size="mini" type="primary" @click="closPer" :class="baseerp+'btn'" :disabled="disabled">{{$t('button_confirm')}}</el-button>
                    <el-button size="mini" @click="closPer">{{$t('button_cancel')}}</el-button>
                </div>
            </el-dialog>

    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import ProductDetails from "./ProductDetails";
    export default {
        name: "ApplicationForm",
        components: {ProductDetails},
        props:{
            application:{
                type:Object,
                required:true,
            }
        },
        data(){
            return{
                gsname:"",
                bmname:"",
                sqName:"",
                ckname:"",
                groupid:0,
                formData:{
                    gsname:"",
                    bmname:"",
                    sqName:"",
                    ckname:"",
                    num:"000000",
                    vc_note:"",
                    kysl:"",
                    vc_lruname:"",
                    date:"",
                    tableData:[],
                    i_directsell_deptid:0,
                    vc_directsell_deptname:'',
                    i_directsell_uid:0,
                    vc_directsell_uname:'',
                    vc_hqgsname:'',
                    i_hqgsid:0,

                },
                companyName_hq:[],
                formRules:{
                    f_num:[{required:true,message:this.$t('promanagement_please_fill_in_the_outbound_quantity'),trigger:"blur"},],
                },
                companyName:[],
                groupName:[],
                personName:[],
                warehouseName:[],
                tableData:[],
                f_num:"",
                visible:false,
                productDetails:{},
                vc_note:"",
                date:"",
                disabled:false,
                isbtn:false,
                edit:false,
                data:{},
                i_pid:0,
                state:0,
                qgsname:"",
                qckname:"",
                gsid:0,
                gid:0,
                i_rwid:0,
                ckid:0,
                squid:0,
                index:0,
                pageSize:1,
                baseerp:"",
                form:{},
                mid:0,
                dialogVisible:false,
                personData:[],
            }
        },
        watch: {
            application: {
                handler() {
                    if (this.application) {
                        //console.log(this.application,'this.application')
                        this.pageSize=this.application.page_size;
                        this.i_id = this.application.i_id;
                        this.mid = this.application.i_mid;
                        this.i_pid = this.application.i_pid;
                        this.i_type = this.application.i_type;
                        let dtnowtime = `${this.application.value.dt_createtime.slice(0, 4)}-${this.application.value.dt_createtime.slice(4, 6)}-${this.application.value.dt_createtime.slice(6, 8)}`;
                        let dtendtime = `${this.application.value.dt_endtime.slice(0, 4)}-${this.application.value.dt_endtime.slice(4, 6)}-${this.application.value.dt_endtime.slice(6, 8)} 23:59:59`;
                        this.formData={
                            gsname:this.application.value.vc_gsname,
                            bmname:this.application.value.vc_cjname,
                            sqName: sessionStorage.getItem("lruname"),
                            ckname:this.application.value.vc_ckname,
                            num:this.i_pid,
                            // vc_note:this.application.vc_note,
                            vc_lruname: sessionStorage.getItem("lruname"),
                            date:dtnowtime,
                            dt_accounttime:this.application.jz==false?dtendtime:dtnowtime,
                            vc_hqgsname:this.application.value.vc_gsname,
                            i_hqgsid:this.application.value.i_gsid,
                            i_directsell_deptid:0,
                            vc_directsell_deptname:'',
                            i_directsell_uid:0,
                            vc_directsell_uname:'',
                        };
                        //console.log(this.formData,'formData')
                        this.gsid=this.application.value.i_gsid;
                        this.gid=this.application.value.i_cjid;
                        this.ckid=this.application.value.i_ckid;
                        this.getCompanyList();
                        if ((this.i_pid ?? '' !== '') && this.i_pid != 0) {
                            this.edit = true;
                            this.getPickingListSc();
                        } else if (this.i_pid == 0) {
                            this.productDetails.gsid=this.application.value.i_gsid;
                            this.productDetails.i_mid=this.mid;
                            this.productDetails.i_type=this.i_type;
                            this.productDetails.ckid=this.application.value.i_ckid;
                            this.productDetails.gsid_out=this.application.value.i_gsid_out;
                            this.productDetails.i_pzid=this.application.value.i_pzid;
                            this.productDetails.selected=[];
                            this.edit = false;

                            /*this.getGroupList();
                            this.getWarehouseList();*/
                            this.getDateYYYYMMddHHMMSS();
                        }
                        // console.log(this.application, "this.application");
                    }
                },
                immediate: true,
                deep: true
            }
        },
        mounted() {
            this.baseerp=baseerp;
            //console.log(this.application,"-----------")
        },
        methods:{
            searchdata(e){
                console.log(e,'e')
                if(e){
                    this.getSellDirectUser(e)
                }else{
                    this.formData.i_directsell_deptid=0;
                    this.formData.vc_directsell_deptname='';
                    this.formData.i_directsell_uid=0;
                    this.formData.vc_directsell_uname='';
                }

            },
            async getSellDirectUser(e){
                let param={
                    i_gsid: this.formData.i_hqgsid,
                    vc_name:e
                };
                let res=await API.getSellDirectUser(param);
                if(res.code==1){
                    if (res.data.length>0){
                        this.personData=res.data;
                        this.dialogVisible=true;
                    }

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            rowClick(row){
                console.log(row, row.index,'row')
                this.formData.i_directsell_deptid=row.i_directsell_deptid;
                this.formData.vc_directsell_deptname=row.vc_directsell_deptname;
                this.formData.i_directsell_uid=row.i_directsell_uid;
                this.formData.vc_directsell_uname=row.vc_directsell_uname;
            },
            closPer(){
                this.dialogVisible=false;
            },
            async getCompanyList(){
                let param={
                    i_mid: this.mid,
                    i_type:"0,2",
                    isNoRight:1,
                };
                let res=await API.getCompanyList(param);
                if(res.code==1){
                    if (res.data.length>0){
                        this.companyName_hq=res.data;
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getPickingListSc(){
                let param={
                    i_mid:this.mid,
                    i_pid:this.i_pid,
                };
                let res=await API.getPickingListSc(param);
                if(res.code==1){
                    let data=res.data;
                    this.formRules={};$
                    this.formData={
                        gsname:data.vc_outgsname,
                        //bmname:data.vc_outcjname,//20260127zhu
                        bmname:data.vc_cjname,
                        sqName:data.vc_squname,
                        ckname:data.vc_outckname,
                        num:data.i_id,
                        vc_note:data.vc_note,
                        vc_lruname:data.vc_lruname,
                        date:data.dt_createtime,
                        dt_accounttime:data.dt_accounttime,
                        tableData:data.details,
                        i_directsell_deptid:data.i_directsell_deptid,
                        vc_directsell_deptname:data.vc_directsell_deptname,
                        i_directsell_uid:data.i_directsell_uid,
                        vc_directsell_uname:data.vc_directsell_uname,
                        vc_hqgsname:data.vc_hqgsname,
                        i_hqgsid:data.i_hqgsid,
                    };
                    // this.state=data.i_state;
                    this.tableData=data.details;
                    this.gsid=data.i_outgsid;
                    this.gid=data.i_cjid;
                    this.squid=data.i_squid;
                    this.sqName=data.vc_squname;
                    this.i_lruid=data.i_lruid;
                    this.i_lruname=data.i_lruname;
                    this.ckid=data.i_outckid;
                    this.productDetails.gsid=data.i_gsid;
                    this.productDetails.i_mid=this.mid;
                    this.productDetails.ckid=data.i_ckid;
                    this.productDetails.gsid_out=data.i_gsid_out;
                    this.productDetails.i_pzid=data.i_pzid;
                    this.productDetails.i_type=data.i_type;
                    this.productDetails.selected=[];
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            numinput(value){
                if (value.f_num>value.kysl) {
                    value.f_num=value.kysl;
                    this.$message.error(this.$t('promanagement_the_requested_outbound_quantity_should_be_less_than_the_available_inventory'));
                    return false
                }
            },
            popShow(){
                //console.log(this.visible)
                this.productDetails.i_hqgsid=this.formData.i_hqgsid;
                if (this.formData.gsname==''||this.formData.ckname==''){
                    this.$message.error(this.$t('promanagement_please_select_company_or_warehouse'))
                    return
                }else if(this.formData.gsname!=''&&this.formData.ckname!=''){
                    this.visible=true;
                }
                if (this.visible==true){
                    this.isbtn=true
                }
            },
            closePop(){
                this.visible=false;
                this.isbtn=false;
            },
            //产品列表
            transValue(value){
                /*let arr=[];
                if ( this.formData.tableData.length>0){

                }else {
                     arr=[...value];
                }*/
                let arr=[...this.tableData,...value];
                // console.log(value,"------------")

                //console.log(arr,"arrrrrrrrrrrrr")
                /*const vc_pzid='vc_pzid';
                const vc_no='vc_no';
                const i_scid='i_scid';
                //console.log(item,"--item--",next)
                const newArr = arr.reduce((all,next)=>all.some((item)=>item[vc_pzid]==next[vc_pzid])?all:[...all,next],[]);
                const newArr2 = newArr.reduce((all,next)=>all.some((item)=>item[vc_no]==next[vc_no])?all:[...all,next],[]);
                const newArr3 = newArr2.reduce((all,next)=>all.some((item)=>item[i_scid]==next[i_scid])?all:[...all,next],[]);

*/
                let hash = {};
                arr = arr.reduce(function(item, next) {
                    hash[next.vc_unique] ? '' : hash[next.vc_unique] = true && item.push(next);
                    return item
                }, []);
                this.formData.tableData=arr;
                 this.tableData=arr;
                this.productDetails.selected=this.tableData;
                //console.log("**arr**",newArr3)
            },
            deleteRow(value,index){
                this.index=index;
                    this.tableData.splice(this.index,1);
               // console.log(value,"-----")
            },
            //提交审批
            toApprove(){
            },
            cancel(){
                //console.log(this.pageSize,"------")
                this.visible=false;
                this.$emit('close');

                //this.$emit('getPickingReqList')
            },
            //保存
           async saveForm(){
               if(this.formData.i_hqgsid!==this.gsid&&(this.formData.i_directsell_uid==0||this.formData.i_directsell_deptid==0)){
                   console.log(this.formData.i_hqgsid,this.gsid)
                   console.log(this.formData.i_directsell_uid)
                   console.log(this.formData.i_directsell_deptid)
                   this.$message.error(this.$t('promanagement_directly_affiliated_departments_and_businesses_cannot_be_left_blank'));
                   return ;
               }
               let details = this.tableData.filter(item=>item.f_num!=0);
               if (details.length==0){
                   this.$message.error(this.$t('promanagement_please_add_the_requested_outbound_quantity'));
                   return ;
               }
               this.disabled=true;
                let param={
                    i_mid: this.mid,
                    i_id:this.i_pid,
                    i_rwid:this.i_id,
                    i_outgsid:this.gsid,
                    i_cjid:this.gid,
                    i_outckid:this.ckid,
                    i_squid:sessionStorage.getItem("userid"),
                    vc_squname:sessionStorage.getItem("lruname"),
                    vc_note:this.formData.vc_note,
                    details:details,
                    dt_accounttime:this.formData.dt_accounttime,
                    i_directsell_deptid:this.formData.i_directsell_deptid,
                    vc_directsell_deptname:this.formData.vc_directsell_deptname,
                    i_directsell_uid:this.formData.i_directsell_uid,
                    vc_directsell_uname:this.formData.vc_directsell_uname,
                    i_hqgsid:this.formData.i_hqgsid,
                };
                let res=await API.savePickingListSc(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.visible=false;
                    this.$emit('getPickingReqList',this.pageSize)
                    this.cancel();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.formData.date=`${date.getFullYear()}-${month}-${strDate}`;
                //console.log(this.formData.date)
            },
            tableRowClassName({row,rowIndex}){
                //console.log(row.i_gsid,this.gsid)
                /*if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }*/
                if (row.isother == 1) {
                    return 'danger-row';
                }
            },
        }
    }
</script>

<style lang="scss" >
    .form{
        display: flex;
        flex-wrap: wrap;
    }
    .form .el-form-item{
        width: 33.33%;
        margin-right: 0;
    }
    .flex{
        display: flex;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
    }
    .num .el-form-item__label {
            color: #b3d268;
            font-size: 16px;
            font-style: italic;
        }
        .num .el-form-item__content {
            width: 130px;
        }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .tableForm-item{
        margin: 0;
        width: 100%;
        /deep/{
            .el-form-item__content{
                width: 100%;
                margin-left: 0 !important;
            }
        }
    }
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
    }
    .table {
        .el-form-item--mini.el-form-item, .table.el-form-item--small.el-form-item {
            margin-bottom: 0px;
        }
    }
        /deep/{
            .table {
                 .el-form-item--mini.el-form-item, .table.el-form-item--small.el-form-item {
                     margin-bottom: 0px;
                 }
             }
            .el-input__inner {
                height: 24px;
                line-height: 24px;

            }
            .cell .el-input__inner{
                height: 24px;
                line-height: 24px;
            }
            .el-table .cell{
                height: 24px;
                line-height: 24px;
            }
            .el-input-number--mini {
                width: 96px;
                line-height: 26px;
            }
            .danger-row{
                color: #999;
            }
        }

</style>
